import Vue from 'vue'

import ErrorState from './states/ErrorState'

Vue.component('error-state', ErrorState)
